'use client';
import { ButtonAdvertising } from '@/shared/ui/desktop/button-advertising';

export const LearnMoreButton = () => {
  return <ButtonAdvertising label={'Learn More'} />;
};
